import axiosInstance from "../axiosInstance";

// const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
// const BASE_URL = `${API_BASE}/system/notifications`;

const BASE_URL = "/system/notifications";



/* =========================================================
📢 Đăng ký thiết bị nhận thông báo (PWA / Mobile)
========================================================= */
export const subscribeNotification = async (subscriptionData) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/subscribe`, subscriptionData);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi đăng ký thiết bị nhận thông báo:", error);
    throw error.response?.data || { message: "Không thể đăng ký thông báo" };
  }
};

/* =========================================================
📩 Gửi thông báo (đa module)
========================================================= */
export const sendNotification = async (payload) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/send`, payload);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi gửi thông báo:", error);
    throw error.response?.data || { message: "Không thể gửi thông báo" };
  }
};

/* =========================================================
🔔 Lấy danh sách thông báo của user hiện tại (phân trang)
params: { page, limit, status: 'all'|'unread' }
returns: { items, total, page, limit, total_pages }
========================================================= */
export const getNotifications = async (params = {}) => {
  try {
    const res = await axiosInstance.get(BASE_URL, {
      params: {
        page: params.page || 1,
        limit: params.limit || 20,
        status: params.status || "all",
      },
    });
    const data = res.data || {};
    return {
      items: data.items || [],
      total: Number(data.total) || 0,
      page: Number(data.page) || 1,
      limit: Number(data.limit) || 20,
      total_pages: Number(data.total_pages) || 1,
    };
  } catch (error) {
    console.error("❌ Lỗi khi tải danh sách thông báo:", error);
    throw error.response?.data || { message: "Không thể tải thông báo" };
  }
};

/* =========================================================
🗑 Xóa toàn bộ thông báo của user
========================================================= */
export const clearAllNotifications = async () => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/clear-all`);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi xóa toàn bộ thông báo:", error);
    throw error.response?.data || { message: "Không thể xóa toàn bộ thông báo" };
  }
};

/* =========================================================
✅ Đánh dấu đã đọc thông báo
========================================================= */
export const markNotificationsRead = async (ids) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/mark-read`, { ids });
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi đánh dấu đã đọc:", error);
    throw error.response?.data || { message: "Không thể đánh dấu thông báo đã đọc" };
  }
};

/* =========================================================
✅ Đánh dấu tất cả đã đọc
========================================================= */
export const markAllNotificationsRead = async () => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/mark-all-read`);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi đánh dấu tất cả đã đọc:", error);
    throw error.response?.data || { message: "Không thể đánh dấu tất cả đã đọc" };
  }
};

/* =========================================================
🗑 Xóa thông báo khỏi danh sách người nhận
========================================================= */
export const deleteNotification = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi xóa thông báo:", error);
    throw error.response?.data || { message: "Không thể xóa thông báo" };
  }
};


/* =========================================================
🔢 Lấy số lượng thông báo chưa đọc
========================================================= */
export const getUnreadCount = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/unread-count`);
    return {
      count: res.data.count || 0,
      mandatory_unread: res.data.mandatory_unread || 0,
    };
  } catch (error) {
    console.error("❌ Lỗi khi lấy số lượng thông báo chưa đọc:", error);
    return { count: 0, mandatory_unread: 0 };
  }
};


/* =========================================================
📢 Tạo thông báo hệ thống (gửi đến toàn bộ user)
========================================================= */
export const createSystemNotification = async (data) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/system`, data);
    return res.data;  // trả về message từ BE
  } catch (error) {
    console.error("❌ Lỗi khi tạo thông báo hệ thống:", error);
    throw error; // để UI biết lỗi và show toast
  }
};


/* =========================================================
📜 Lấy danh sách thông báo toàn hệ thống (bảng quản lý)
========================================================= */
export const getAllNotifications = async (params = {}) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/list`, { params });
    return res.data;   // { data: [], total: 100 }
  } catch (error) {
    console.error("❌ Lỗi khi tải danh sách thông báo:", error);
    throw error.response?.data || { message: "Không thể tải danh sách thông báo" };
  }
};


/* =========================================================
📄 Lấy chi tiết 1 thông báo
========================================================= */
export const getNotificationById = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi tải chi tiết thông báo:", error);
    throw error.response?.data || { message: "Không thể tải chi tiết thông báo" };
  }
};


/* =========================================================
📩 Tạo thông báo đến danh sách người nhận
========================================================= */
export const createCustomNotification = async (data) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/create`, data);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi tạo thông báo tùy chỉnh:", error);
    throw error.response?.data || { message: "Không thể tạo thông báo" };
  }
};

/* =========================================================
📣 Admin: gửi theo nhóm + popup bắt buộc (mandatory)
POST /admin-broadcast
========================================================= */
export const postAdminBroadcast = async (payload) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/admin-broadcast`, payload);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể gửi thông báo";
    console.error("❌ postAdminBroadcast:", msg, error);
    throw new Error(msg);
  }
};

/* =========================================================
🔔 Thông báo admin chưa đọc (popup bắt buộc)
========================================================= */
export const getPendingMandatoryNotifications = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/pending-mandatory`);
    return res.data.items || [];
  } catch (error) {
    console.error("❌ getPendingMandatoryNotifications:", error);
    return [];
  }
};

/* =========================================================
🔧 Tắt app tạm thời (bảo trì)
========================================================= */
export const getAppMaintenanceStatus = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/maintenance`, {
      skipGlobalErrorToast: true,
    });
    return res.data || { enabled: false };
  } catch (error) {
    console.error("❌ getAppMaintenanceStatus:", error);
    return { enabled: false };
  }
};

export const disableAppMaintenance = async () => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/maintenance/disable`);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể mở lại ứng dụng";
    console.error("❌ disableAppMaintenance:", msg, error);
    throw new Error(msg);
  }
};

/* =========================================================
⚙️ Tùy chọn nhận thông báo (in-app / email)
========================================================= */
export const getNotificationPreferences = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/preferences`);
  return res.data;
};

export const updateNotificationPreferences = async (payload) => {
  const res = await axiosInstance.put(`${BASE_URL}/preferences`, payload);
  return res.data;
};
